import { graphql, useStaticQuery } from 'gatsby';
export const useMedia = () => {
    const query = useStaticQuery(graphql `
      query usePodcasts {
        cosmos {
          pages {
            page: podcast(dataKey: "page") {
              top_copy {
                header
                description
                icon {
                  ticket
                  fileName
                }
              }
            }
          }
          collections {
            podcastepisodes {
              title
              description
              soundcloud_id
              vimeo_id
            }
          }
        }
      }
    `);
    return {
        page: query.cosmos.pages.page,
        podcastEpisodes: query.cosmos.collections.podcastepisodes,
    };
};
export default useMedia;
